<template>
  <!-- <vue-perfect-scrollbar
    class="drawer-menu--scroll"
    :settings="scrollSettings"
  > -->
  <div id="appRoot">
    <template v-if="!$route.meta.public">
      <v-app
        id="inspire"
        class="app"
      >
        <app-drawer class="app--drawer"></app-drawer>
        <app-toolbar class="app--toolbar"></app-toolbar>
        <vue-perfect-scrollbar
          class="drawer-menu--scroll"
          :settings="scrollSettings"
        >
          <v-content>
            <!-- Page Header -->
            <page-header v-if="$route.meta.breadcrumb"></page-header>

            <div class="page-wrapper">
              <router-view></router-view>
            </div>

            <!-- App Footer -->
            <v-footer
              height="auto"
              class="white pa-3 app--footer"
            >
              <span class="caption">Sunward &copy; {{ new Date().getFullYear() }}</span>
              <v-spacer></v-spacer>
              <span class="caption mr-1"> SUNWARD PHARMACEUTICAL SDN BHD </span>
              <v-icon
                color="pink"
                small
              >favorite</v-icon>
            </v-footer>

          </v-content>
        </vue-perfect-scrollbar>
        <!-- Go to top -->
        <app-fab></app-fab>
        <!-- theme setting -->
        <!-- <v-btn
          small
          fab
          dark
          falt
          fixed
          top="top"
          right="right"
          class="setting-fab"
          color="primary"
          @click="openThemeSettings"
        >
          <v-icon>settings</v-icon>
        </v-btn> -->
        <v-navigation-drawer
          class="setting-drawer"
          temporary
          right
          v-model="rightDrawer"
          hide-overlay
          fixed
        >
          <theme-settings></theme-settings>
        </v-navigation-drawer>
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
    </template>
    <v-snackbar
      :timeout="5000"
      top
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <!-- <v-btn
        dark
        flat
        @click.native="snackbar.show = false"
        icon
      >
        <v-icon>close</v-icon>
      </v-btn> -->
    </v-snackbar>
  </div>
  <!-- </vue-perfect-scrollbar> -->
</template>
<script>
import AppDrawer from '@/components/AppDrawer';
import AppToolbar from '@/components/AppToolbar';
import AppFab from '@/components/AppFab';
import PageHeader from '@/components/PageHeader';
import menu from '@/api/menu';
import ThemeSettings from '@/components/ThemeSettings';
import AppEvents from './event';
// delete Confirmation Dialog
import DeleteConfirmationDialog from '@/components/DeleteConfirmationDialog/DeleteConfirmationDialog';

export default {
  components: {
    AppDrawer,
    AppToolbar,
    AppFab,
    PageHeader,
    ThemeSettings,
    DeleteConfirmationDialog,

  },
  data: () => ({
    expanded: true,
    rightDrawer: false,
    snackbar: {
      show: false,
      text: '',
      color: ''
    },
    scrollSettings: {
      maxScrollbarLength: 160
    }
  }),

  computed: {},

  created () {
    AppEvents.forEach(item => {
      this.$on(item.name, item.callback);
    });
    window.getApp = this;

    window.getApp.$on('APP_THEME_TOGGLED', () => {
      this.$vuetify.goTo(0);
      this.rightDrawer = !this.rightDrawer;
    });

  },
  methods: {
    openThemeSettings () {
      this.$vuetify.goTo(0);
      this.rightDrawer = !this.rightDrawer;
    }
  }
};
</script>


<style lang="stylus" scoped>
.setting-fab {
  top: 12% !important;
  right: 0;
  border-radius: 0;
}

.page-wrapper {
  min-height: calc(100vh - 64px - 50px - 81px);
}

.drawer-menu--scroll {
  height: calc(100vh - 1px);
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue